import axios from 'axios'

export async function sendGet(path, language, params) {
    let setPath = path;
    if (language) {
        setPath = setPath + "/" + language;
    }
    if (params) {
        setPath = setPath + "/" + params;
    }
    return axios({
        method: "GET",
        url: "https://www.archipelagointernational.com/api/sentech/" + setPath,
        data: "",
        headers: {
            Authorization: "Bearer BFyEwXcMdzeGom2STdqK2bf2MA3vAjmR",
        },
    }).then((response) => {
        return response.data;
    });
}

export async function sendPost(path, payload) {
    let setPath = path;
    return axios({
        method: "POST",
        url: "https://www.archipelagointernational.com/api/sentech/" + setPath,
        data: payload,
        headers: {
            Authorization: "Bearer BFyEwXcMdzeGom2STdqK2bf2MA3vAjmR",
        },
    }).then((response) => {
        return response.data;
    });
}

export const AxiosService = {
    sendGet,
    sendPost
}